import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen, IsXsScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const FormTemplatesHelp = () => {
  const isMdScreen = IsMdScreen();
  const paddingValue = IsXsScreen() ? 1 : 3;

  return (
    <>
      <Stack padding={paddingValue} direction={"row"}>
        <ShContainer maxWidth='xl' margin='auto'>
          <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
            Form Templates
          </ResourceTypography>
          <ResourceTypography variant="body1" paragraph>
            Create and manage custom forms for your hiring process. Design application forms,
            assessment questionnaires, and feedback forms to gather the information you need.
          </ResourceTypography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Form Types
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Choose from various form types including job applications, skills assessments,
            reference checks, and interview feedback forms. Customize each form to your needs.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Form Builder
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Use our intuitive form builder to create custom forms. Add different field types,
            set validation rules, and create conditional logic for a dynamic form experience.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Template Library
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Access a library of pre-built form templates for common hiring scenarios.
            Customize these templates to match your specific requirements.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Form Analytics
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Track form completion rates and gather insights from responses. Analyze
            candidate data to improve your hiring process and form effectiveness.
          </Typography>

          <Box paddingTop={2} paddingBottom={3}>
            <ShButton
              component={RouterLink}
              to="/employer/settings/tools/templates/form-templates"
              color="primary"
              variant="contained"
            >
              Manage Form Templates
            </ShButton>
          </Box>
        </ShContainer>
        {!isMdScreen && <CommonQuestionSidebar />}
      </Stack>
    </>
  );
};

export default FormTemplatesHelp; 